import { Loader2Icon } from 'lucide-react';

import { cn } from '@/lib/utils';

function Spinner({ className, ...props }) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  );
}

/**
 * Full-page overlay using Spinner. Call sites control when it is shown;
 * this only provides equivalent layout markup.
 */
function FullPageLoader({ message = '', className, ...props }) {
  return (
    <div
      className={cn('full-page-loader', className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
      {...props}
    >
      <Spinner className="size-11 text-primary" aria-hidden="true" />
      {message ? <div className="full-page-loader-text">{message}</div> : null}
    </div>
  );
}

export { Spinner, FullPageLoader };
